import React, { useState, useEffect } from "react";

const personalInfoContent = [
  { meta: "Prénom", metaInfo: "Amazigh" },
  { meta: "Nom", metaInfo: "BOUGHAREB" },
  { meta: "Àge", metaInfo: "28 ans" },
  // { meta: "Nationalité", metaInfo: "Algérienne" },
  { meta: "Adresse", metaInfo: "Tizi Ouzou" },
  { meta: "Tél", metaInfo: "+213 561 27 91 30" },
  { meta: "Email", metaInfo: "bougharebamazigh@yahoo.fr" },
  { meta: "Langues", metaInfo: "Français, Anglais, Kabyle, Arabe" },
  { meta: "Freelance", metaInfo: "Disponible" },
  
  
  
  // { meta: "Skype", metaInfo: " amazigh.boughareb" },
  
];
const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title info-item">
            {val.meta}:
          </span>
          <span className={`value d-block d-sm-block d-lg-block d-xl--block ${val.meta === "Freelance" ? "blinking" : ""}`}>
            {val.metaInfo}
          </span>
          <br />
          <br />
        </li>
      ))}
    </ul>
  );
};
// const PersonalInfo = () => {
//   return (
//     <ul className="about-list list-unstyled open-sans-font">
//       {personalInfoContent.map((val, i) => (
//         <li key={i}>
//           <span className="title">{val.meta}: </span>
//           <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
//             {val.metaInfo}
//           </span>
//           <br />
//           <br />          
//         </li>
        
//       ))}
//     </ul>
//   );
// };

export default PersonalInfo;
